<template>
  <div class="goal-configuration-wrapper">
    <div class="rf-section-title">
      <span>Select a goal from below.</span>
    </div>
    <div style="max-width: 600px">
      <v-select
        v-model="selectedGoal"
        bgColor="#ffffff"
        variant="outlined"
        density="compact"
        :items="usageTrackers"
        label="Available Goals"
        itemTitle="text"
      />
      <v-text-field
        v-if="selectedGoal"
        v-model="duration"
        label="Attribution duration (hours)"
        persistentPlaceholder
        type="number"
        variant="outlined"
        required
        density="compact"
        hideDetails
        bgColor="#ffffff"
      />
      <RfPromoInteractionInterval
        interactionType="customGoal"
        :action="model.actions.rf_settings_custom_goal_interval"
        style="background-color: #ffffff"
        @setIntervalAction="setIntervalAction"
      />
    </div>
  </div>
</template>

<script>
import RfPromoInteractionInterval from "@/components/RfPromotions/RfPromoInteractionInterval.vue";
import { useAppsStore } from "@/pinia/appsStore";
import { useCustomFields } from "@/utils/composables/useCustomFields";

export default {
  name: "RfGoal",
  components: { RfPromoInteractionInterval },
  props: ["model"],
  setup: () => ({ appsStore: useAppsStore(), customFields: useCustomFields() }),
  data() {
    return {
      selectedGoal:
        this.model.custom_filter && Object.keys(this.model.custom_filter).length > 0
          ? Object.keys(this.model.custom_filter)[0]
          : "",
      duration: this.model.actions.rf_settings_custom_goal_expire_hours || "48",
    };
  },
  computed: {
    usageTrackers() {
      if (!this.appsStore.app) return [];
      let trackers = [{ value: "", text: "None" }];

      trackers = trackers.concat(
        this.customFields.appCustomFields.value
          .filter(item => {
            return (
              item.connector_type === "redfast" &&
              item.is_usage &&
              ["visits", "minutes"].indexOf(item.label) < 0
            );
          })
          .filter(item => {
            if (this.model.device_type === "web") {
              return item.data_type !== "screen";
            }
            return ["page", "track"].indexOf(item.data_type) < 0;
          })
          .map(item => {
            return { value: item.label, text: item.label };
          }),
      );
      return trackers;
    },
  },
  methods: {
    setIntervalAction(value) {
      this.model.actions.rf_settings_custom_goal_interval = value;
    },
    fillModel(model) {
      model.actions.rf_settings_custom_goal_expire_hours = this.duration;
      if (this.selectedGoal) {
        const options =
          model.custom_filter[this.selectedGoal] && model.custom_filter[this.selectedGoal].options;
        model.custom_filter = {
          [this.selectedGoal]: {
            values: [],
            options,
          },
        };
      } else {
        model.custom_filter = {};
      }
    },
  },
};
</script>
